import { tokens } from '@mindtickle/styles/lib';
import styled from 'styled-components';

export const StyledImpersonationBanner = styled.div`
  display: flex;
  padding: 8px 24px;
  align-items: center;
  background: ${tokens.bgTokens.COLOR_BG_ACCENT};
  justify-content: space-between;
  height: 48px;

  .left-impersonation-section {
    display: flex;
    align-items: center;
    flex: 1;
    min-width: 0;
    display: flex;
    align-items: center;
  }

  .impersonated-user-icon {
    font-size: 16px;
    color: ${tokens.iconTokens.COLOR_ICON_INVERSE};
    margin-right: 8px;
  }

  .impersonating-text,
  .impersonating-username {
    color: ${tokens.textTokens.COLOR_TEXT_INVERSE};
    margin-right: 4px;
  }

  .impersonating-username {
    flex: 1;
    min-width: 0;
    display: flex;
    align-items: center;
  }
`;
